import { Card, CardHeader } from "../components/Card";

export const NotFoundPage = () => {
	return (
		<>
			<Card>
				<CardHeader>Page not found</CardHeader>
				<div>This page doesn&apos;t exist</div>
			</Card>
		</>
	);
};
